export const capitalizeFirst = str =>
	str
		.toLowerCase()
		.split(" ")
		.map(w => w.charAt(0).toUpperCase() + w.substring(1))
		.join(" ");

export const capitalizeOne = str => {
	return str
		.charAt(0)
		.toUpperCase()
		.concat(str.slice(1).toLowerCase());
};
